import { ClipboardEvent } from "react";

export function capitalize(val: string) {
	return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

export function copyToClipboard(text: string) {
	const clipboardData = (window as any)
		.clipboardData as ClipboardEvent["clipboardData"];

	if (clipboardData && clipboardData.setData) {
		return clipboardData.setData("Text", text);
	} else if (
		document.queryCommandSupported &&
		document.queryCommandSupported("copy")
	) {
		var textarea = document.createElement("textarea");
		textarea.textContent = text;
		textarea.style.position = "fixed";
		document.body.appendChild(textarea);
		textarea.select();
		try {
			return document.execCommand("copy");
		} finally {
			document.body.removeChild(textarea);
		}
	}
}

export function removeItem<T>(arr: Array<T>, value: T): Array<T> {
	return removeIndex(arr, arr.indexOf(value));
}

export function removeIndex<T>(arr: Array<T>, index: number): Array<T> {
	return arr.splice(index, 1);
}
